import axios from 'axios';
import megatron from '@stencil/megatron';
import sendDataToNewrelic from '@stencil/send-data-to-new-relic';
import sendToClientAnalytics from '@stencil/client-side-analytics/src/send-to-client-analytics';
import { POKUS_EXPERIMENT_URL } from '@stencil/flights-constants/src/urls';

const EXP_IDS = [38, 63, 66, 67, 85, 89, 111, 207, 361, 471];
// 38 : ssr experiment
// 63 : insurance animation experiment
// 67 : GI_FLT_DWEB_NEW_OFFERS_DISCOUNT
// 89 : GI_FLT_RCOM_RID_REPRICE_ADDONS
// 111 : GI_MWEB_MEALS_ADDONS_MANDATORY
// 207 : GI_FLT_FARE_BREAKUP
// 361 : GI_MWEB_SRP_GROUND_UP
// 471 : GI_FLT_HOME

const getExperimentDetails = data => {
  if (data && data?.perLobMap?.FLIGHT?.exp_experiment_details_list) {
    for (let i = 0; i < data.perLobMap.FLIGHT.exp_experiment_details_list.length; i++) {
      // if (data.perLobMap.FLIGHT.exp_experiment_details_list[i].exp_experiment_id === 38) {
      if (
        EXP_IDS.indexOf(data.perLobMap.FLIGHT.exp_experiment_details_list[i].exp_experiment_id) > -1
      ) {
        return data.perLobMap.FLIGHT.exp_experiment_details_list[i];
      }
    }
  }
  return null;
};

export async function assignVariant(requestObj, pdtApiFailureError = err => {}) {
  try {
    const url = POKUS_EXPERIMENT_URL;

    var header = new Headers();
    header.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8;');

    const apiName = 'pokus_assignVariant_api';
    sendToClientAnalytics({
      serviceApp: 'aerial',
      apiName,
      deviceid: requestObj?.user?.deviceId || '',
      stage: 'pokus:assignVariant_init'
    });
    const response = await megatron({
      name: apiName,
      headers: header,
      type: 'POST',
      url: url,
      credentials: 'same-origin', // pokus as allow origin set to *, hence credetial cannot be include
      requestData: JSON.stringify(requestObj),
      pdtApiFailureError
    });

    if (response) {
      const expDetails = getExperimentDetails(response);
      sendToClientAnalytics({
        serviceApp: 'aerial',
        apiName,
        deviceid: requestObj?.user?.deviceId || '',
        exp_id: expDetails.exp_experiment_id || '',
        exp_variant_id: expDetails.exp_experiment_variant_id || '',
        stage: 'pokus:assignVariant_success'
      });
      return response;
    }

    return null;
  } catch (e) {
    sendDataToNewrelic('pokus:assignVariant', `Failed with error: ${e}`);
  }
}

export async function assignVariantOnServer(requestObj, pdtApiFailureError = err => {}) {
  try {
    const url = POKUS_EXPERIMENT_URL;
    const header = {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8;'
    };

    const apiName = 'pokus_assignVariant_api';
    sendToClientAnalytics({
      serviceApp: 'aerial',
      apiName,
      deviceid: requestObj?.user?.deviceId || '',
      stage: 'pokus:assignVariant_init'
    });
    const response = await axios.post(url, requestObj, {
      headers: header,
      timeout: 2000,
      withCredentials: false
    });

    if (response) {
      const expDetails = getExperimentDetails(response?.data);
      sendToClientAnalytics({
        serviceApp: 'aerial',
        apiName,
        deviceid: requestObj?.user?.deviceId || '',
        exp_id: expDetails.exp_experiment_id || '',
        exp_variant_id: expDetails.exp_experiment_variant_id || '',
        stage: 'pokus:assignVariant_success'
      });
      return response?.data;
    }

    return null;
  } catch (e) {
    const id = requestObj?.user?.deviceId;
    console.log('LOG error in assignVariantOnServer [', id, '] ', e);
    sendDataToNewrelic('pokus:assignVariant', `Failed with error: ${e}`);
  }
}
